import React, {useState} from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import "./index.css";
import ChatWindowAttachmentDropdown from "../chat-window-attachment-dropdown";
import assets from "../../../util/assets";
import ChatWindowSmileyDropdown from "../chat-window-smiley-dropdown";

ChatWindowInputToolbar.propTypes = {};

function ChatWindowInputToolbar(props) {

    const [text, setText] = useState('');

    const onChangeText = (text) => {
        setText(text)
    }

    const onKeyDown = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            _onSend();
            e.preventDefault();
        }
        return false;
    }

    const _onSend = ()=>{
        if(text.trim().length > 0){
            const {onSend} = props;
            onSend({text: text.trim()});
            setText('')
        }
    }

    const setChosenEmoji = (emojiObject)=>{
        setText(`${text} ${emojiObject.native} `)
    }

    return (
        <div className="display-flex-align-center chat-window-input-toolbar">
            <TextareaAutosize
                className="textarea"
                onKeyDown={e => onKeyDown(e)}
                placeholder={"Type a message"}
                onChange={event => onChangeText(event.target.value)}
                value={text}
            />
            <div className="display-flex">
                <ChatWindowSmileyDropdown setChosenEmoji={setChosenEmoji}/>
                {
                    props.broadcaster !== null &&
                    <ChatWindowAttachmentDropdown
                        uploadFromPC={props.uploadFromPC}
                        broadcaster={props.broadcaster}
                        setAttachmentModal={props.setAttachmentModal}/>
                }
                <img className="cursor-pointer padding-16" src={assets.messaging.bottom.send} id={`chat-window-send`}
                     onClick={_onSend}/>
            </div>
        </div>
    );
}

export default ChatWindowInputToolbar;